import { useEffect } from 'react';
import {
	useGICLifeCycleEvents,
	GIC_LIFECYCLE_EVENTS,
} from '@atlassian/jira-issue-create-extensibility';
import { useFormContext } from './index';

export const usePublishFormContext = () => {
	const [state] = useFormContext();
	const { publish } = useGICLifeCycleEvents();

	useEffect(() => {
		publish(GIC_LIFECYCLE_EVENTS.FORM_CONTEXT_STATE_CHANGE, state);
	}, [publish, state]);
};
